// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --wish-bg: #f2f6fc;
  --wish-surface: #ffffff;
  --wish-surface-soft: #f7fbff;
  --wish-text: #122940;
  --wish-muted: #667f97;
  --wish-border: #d8e6f4;
  --wish-brand: #0f62ad;
  --wish-brand-dark: #0a4f8f;
  --wish-success: #1d9a57;
  --wish-danger: #e44a3b;
  --wish-shadow-soft: 0 10px 26px rgba(13, 37, 64, 0.08);
  --wish-shadow-raise: 0 16px 34px rgba(13, 37, 64, 0.13);
}

.wishlist-container {
  width: min(96%, 1220px);
  margin: 20px auto 0;
  padding: clamp(16px, 2.8vw, 28px);
  text-align: center;
  background:
    radial-gradient(circle at 92% 4%, rgba(191, 216, 240, 0.38) 0%, rgba(191, 216, 240, 0) 35%),
    radial-gradient(circle at 8% 16%, rgba(255, 255, 255, 0.84) 0%, rgba(255, 255, 255, 0) 30%),
    linear-gradient(180deg, #f9fcff 0%, var(--wish-bg) 100%);
  border-radius: 24px;
  box-sizing: border-box;
}

.wishlist-header {
  margin-bottom: 16px;
}

.wishlist-header h1 {
  margin: 0;
  font-size: clamp(1.8rem, 2.8vw, 2.4rem);
  color: var(--wish-text);
  letter-spacing: 0.2px;
}

.wishlist-header p {
  margin: 8px auto 0;
  max-width: 62ch;
  color: var(--wish-muted);
  font-size: 0.98rem;
}

.wishlist-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 14px;
  margin-top: 24px;
  margin-bottom: 24px;
}

.wishlist-card {
  background: var(--wish-surface);
  border-radius: 16px;
  padding: 12px;
  box-shadow: var(--wish-shadow-soft);
  border: 1px solid var(--wish-border);
  transition:
    transform 0.25s ease,
    box-shadow 0.25s ease,
    border-color 0.25s ease;
  text-align: left;
}

.wishlist-card:hover {
  transform: translateY(-5px);
  box-shadow: var(--wish-shadow-raise);
  border-color: #bfd7ee;
}

.wishlist-card img {
  width: 100%;
  height: 170px;
  object-fit: contain;
  border-radius: 12px;
  border: 1px solid #e3edf8;
  background: var(--wish-surface-soft);
  padding: 8px;
  box-sizing: border-box;
}

.wishlist-card h3 {
  font-size: 0.96rem;
  margin: 12px 0 6px;
  color: var(--wish-text);
  line-height: 1.35;
  min-height: 2.7em;
}

.wishlist-card p {
  font-size: 0.95rem;
  font-weight: 800;
  color: var(--wish-brand-dark);
  margin: 0;
}

.wishlist-buttons {
  margin-top: 12px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.move-btn,
.remove-btn {
  border: none;
  min-height: 38px;
  border-radius: 10px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.2px;
  transition: transform 0.2s ease, filter 0.2s ease;
}

.move-btn {
  background: linear-gradient(120deg, #1da35c 0%, #167e47 100%);
  color: #ffffff;
}

.remove-btn {
  background: #fff4f2;
  color: #c53f32;
  border: 1px solid #f5beb7;
}

.move-btn:hover,
.remove-btn:hover {
  transform: translateY(-1px);
  filter: brightness(1.03);
}

.continue-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  background: linear-gradient(120deg, var(--wish-brand) 0%, var(--wish-brand-dark) 100%);
  color: white;
  padding: 12px 20px;
  border-radius: 10px;
  transition: transform 0.2s ease, filter 0.2s ease;
  font-weight: 700;
  letter-spacing: 0.2px;
}

.continue-btn:hover {
  transform: translateY(-1px);
  filter: brightness(1.04);
}

.wishlist-empty-state {
  margin-top: 20px;
  border: 1px solid var(--wish-border);
  background: var(--wish-surface);
  border-radius: 16px;
  box-shadow: var(--wish-shadow-soft);
  padding: 24px;
}

.wishlist-empty-state h2 {
  margin: 0 0 8px;
  color: var(--wish-text);
  font-size: 1.35rem;
}

.wishlist-empty-state p {
  margin: 0;
  color: var(--wish-muted);
}

.wishlist-empty-state .continue-btn {
  margin-top: 14px;
}

@media (max-width: 768px) {
  .wishlist-container {
    width: 94%;
    border-radius: 16px;
    padding: 14px;
  }

  .wishlist-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
  }

  .wishlist-card {
    padding: 10px;
    border-radius: 12px;
  }

  .wishlist-card img {
    height: 130px;
  }

  .wishlist-card h3 {
    font-size: 0.86rem;
  }

  .wishlist-card p {
    font-size: 0.85rem;
  }

  .wishlist-buttons {
    grid-template-columns: 1fr;
  }

  .move-btn,
  .remove-btn {
    min-height: 34px;
    font-size: 12px;
  }
}

/* Match shared Footer style with homepage */
.blue-text {
  color: #3391ff;
}

.yellow-text {
  color: #f3bd29;
}

.footer {
  --footer-bg: linear-gradient(140deg, #12283f 0%, #173b5d 52%, #1f4f78 100%);
  --footer-text: #e8f0f8;
  --footer-muted: #c7d5e3;
  --footer-border: rgba(255, 255, 255, 0.14);
  --footer-highlight: #f3bd29;
  margin: 70px 0 -12px;
  padding: 40px clamp(18px, 3vw, 42px) 18px;
  color: var(--footer-text);
  background: var(--footer-bg);
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 -18px 42px rgba(8, 29, 47, 0.2);
  box-sizing: border-box;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.footer-main {
  width: min(1240px, 100%);
  margin: 0 auto;
  display: grid;
  grid-template-columns: minmax(260px, 1.3fr) minmax(160px, 1fr) minmax(160px, 1fr) minmax(220px, 1.1fr);
  gap: clamp(18px, 3vw, 36px);
  align-items: flex-start;
}

.footer-brand-block {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.footer-brand {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
}

.footer-brand img {
  width: 64px;
  height: 64px;
  object-fit: contain;
}

.footer-brand h2 {
  margin: 0;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: clamp(22px, 2.1vw, 28px);
  letter-spacing: 0.02em;
}

.footer-description {
  margin: 0;
  max-width: 34ch;
  color: var(--footer-muted);
  line-height: 1.65;
  font-size: 14px;
}

.footer-contact-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.footer-contact-list a {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: var(--footer-text);
  text-decoration: none;
  font-size: 14px;
  width: fit-content;
}

.footer-contact-list a:hover {
  color: var(--footer-highlight);
}

.footer-contact-list a svg {
  color: var(--footer-highlight);
  flex-shrink: 0;
}

.footer-link-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.footer-link-group h3,
.footer-social-block h3 {
  margin: 0 0 8px;
  font-size: 18px;
  color: #ffffff;
  letter-spacing: 0.01em;
}

.footer-link-group a {
  color: var(--footer-muted);
  text-decoration: none;
  font-size: 14px;
  width: fit-content;
  transition: color 0.2s ease;
}

.footer-link-group a:hover {
  color: #ffffff;
}

.footer-social-block {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.footer-social-block p {
  margin: 0;
  color: var(--footer-muted);
  line-height: 1.6;
  font-size: 14px;
}

.footer-social-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(120px, 1fr));
  gap: 10px;
}

.footer-social-item {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 42px;
  border: 1px solid var(--footer-border);
  border-radius: 999px;
  color: #ffffff;
  text-decoration: none;
  font-size: 13px;
  font-weight: 600;
  background: rgba(255, 255, 255, 0.06);
  transition:
    transform 0.2s ease,
    background-color 0.2s ease,
    border-color 0.2s ease;
}

.footer-social-item:hover {
  transform: translateY(-2px);
  background: rgba(255, 255, 255, 0.14);
  border-color: rgba(255, 255, 255, 0.26);
}

.footer-bottom {
  width: min(1240px, 100%);
  margin: 28px auto 0;
  padding-top: 14px;
  border-top: 1px solid rgba(255, 255, 255, 0.16);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  color: var(--footer-muted);
  font-size: 13px;
}

.footer-bottom-links {
  display: flex;
  align-items: center;
  gap: 16px;
}

.footer-bottom-links a {
  color: var(--footer-muted);
  text-decoration: none;
}

.footer-bottom-links a:hover {
  color: #ffffff;
}

@media screen and (max-width: 1080px) {
  .footer-main {
    grid-template-columns: repeat(2, minmax(220px, 1fr));
  }
}

@media screen and (max-width: 768px) {
  .footer {
    margin-top: 48px;
    padding: 30px 16px 90px;
  }

  .footer-main {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  .footer-social-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .footer-bottom {
    flex-direction: column;
    align-items: flex-start;
    font-size: 12px;
  }

  .footer-bottom-links {
    gap: 12px;
    flex-wrap: wrap;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/WishlistPage/wishlist.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,4BAA4B;EAC5B,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,sDAAsD;EACtD,uDAAuD;AACzD;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,iCAAiC;EACjC,kBAAkB;EAClB;;;4DAG0D;EAC1D,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,uCAAuC;EACvC,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,mCAAmC;EACnC,oCAAoC;EACpC;;;2BAGyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,oCAAoC;EACpC,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,sFAAsF;EACtF,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,iDAAiD;EACjD,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,+BAA+B;EAC/B,mBAAmB;EACnB,mCAAmC;EACnC,aAAa;AACf;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,gDAAgD;IAChD,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA,4CAA4C;AAC5C;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2EAA2E;EAC3E,sBAAsB;EACtB,uBAAuB;EACvB,0CAA0C;EAC1C,2BAA2B;EAC3B,oBAAoB;EACpB,yCAAyC;EACzC,yBAAyB;EACzB,4BAA4B;EAC5B,+CAA+C;EAC/C,6CAA6C;EAC7C,sBAAsB;EACtB,4DAA4D;AAC9D;;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd,aAAa;EACb,sGAAsG;EACtG,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,eAAe;EACf,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,sCAAsC;EACtC,oBAAoB;EACpB,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC;;;0BAGwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;EACjB,+CAA+C;EAC/C,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,oDAAoD;EACtD;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,eAAe;EACjB;AACF","sourcesContent":[":root {\n  --wish-bg: #f2f6fc;\n  --wish-surface: #ffffff;\n  --wish-surface-soft: #f7fbff;\n  --wish-text: #122940;\n  --wish-muted: #667f97;\n  --wish-border: #d8e6f4;\n  --wish-brand: #0f62ad;\n  --wish-brand-dark: #0a4f8f;\n  --wish-success: #1d9a57;\n  --wish-danger: #e44a3b;\n  --wish-shadow-soft: 0 10px 26px rgba(13, 37, 64, 0.08);\n  --wish-shadow-raise: 0 16px 34px rgba(13, 37, 64, 0.13);\n}\n\n.wishlist-container {\n  width: min(96%, 1220px);\n  margin: 20px auto 0;\n  padding: clamp(16px, 2.8vw, 28px);\n  text-align: center;\n  background:\n    radial-gradient(circle at 92% 4%, rgba(191, 216, 240, 0.38) 0%, rgba(191, 216, 240, 0) 35%),\n    radial-gradient(circle at 8% 16%, rgba(255, 255, 255, 0.84) 0%, rgba(255, 255, 255, 0) 30%),\n    linear-gradient(180deg, #f9fcff 0%, var(--wish-bg) 100%);\n  border-radius: 24px;\n  box-sizing: border-box;\n}\n\n.wishlist-header {\n  margin-bottom: 16px;\n}\n\n.wishlist-header h1 {\n  margin: 0;\n  font-size: clamp(1.8rem, 2.8vw, 2.4rem);\n  color: var(--wish-text);\n  letter-spacing: 0.2px;\n}\n\n.wishlist-header p {\n  margin: 8px auto 0;\n  max-width: 62ch;\n  color: var(--wish-muted);\n  font-size: 0.98rem;\n}\n\n.wishlist-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 14px;\n  margin-top: 24px;\n  margin-bottom: 24px;\n}\n\n.wishlist-card {\n  background: var(--wish-surface);\n  border-radius: 16px;\n  padding: 12px;\n  box-shadow: var(--wish-shadow-soft);\n  border: 1px solid var(--wish-border);\n  transition:\n    transform 0.25s ease,\n    box-shadow 0.25s ease,\n    border-color 0.25s ease;\n  text-align: left;\n}\n\n.wishlist-card:hover {\n  transform: translateY(-5px);\n  box-shadow: var(--wish-shadow-raise);\n  border-color: #bfd7ee;\n}\n\n.wishlist-card img {\n  width: 100%;\n  height: 170px;\n  object-fit: contain;\n  border-radius: 12px;\n  border: 1px solid #e3edf8;\n  background: var(--wish-surface-soft);\n  padding: 8px;\n  box-sizing: border-box;\n}\n\n.wishlist-card h3 {\n  font-size: 0.96rem;\n  margin: 12px 0 6px;\n  color: var(--wish-text);\n  line-height: 1.35;\n  min-height: 2.7em;\n}\n\n.wishlist-card p {\n  font-size: 0.95rem;\n  font-weight: 800;\n  color: var(--wish-brand-dark);\n  margin: 0;\n}\n\n.wishlist-buttons {\n  margin-top: 12px;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n}\n\n.move-btn,\n.remove-btn {\n  border: none;\n  min-height: 38px;\n  border-radius: 10px;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 0.2px;\n  transition: transform 0.2s ease, filter 0.2s ease;\n}\n\n.move-btn {\n  background: linear-gradient(120deg, #1da35c 0%, #167e47 100%);\n  color: #ffffff;\n}\n\n.remove-btn {\n  background: #fff4f2;\n  color: #c53f32;\n  border: 1px solid #f5beb7;\n}\n\n.move-btn:hover,\n.remove-btn:hover {\n  transform: translateY(-1px);\n  filter: brightness(1.03);\n}\n\n.continue-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  text-decoration: none;\n  background: linear-gradient(120deg, var(--wish-brand) 0%, var(--wish-brand-dark) 100%);\n  color: white;\n  padding: 12px 20px;\n  border-radius: 10px;\n  transition: transform 0.2s ease, filter 0.2s ease;\n  font-weight: 700;\n  letter-spacing: 0.2px;\n}\n\n.continue-btn:hover {\n  transform: translateY(-1px);\n  filter: brightness(1.04);\n}\n\n.wishlist-empty-state {\n  margin-top: 20px;\n  border: 1px solid var(--wish-border);\n  background: var(--wish-surface);\n  border-radius: 16px;\n  box-shadow: var(--wish-shadow-soft);\n  padding: 24px;\n}\n\n.wishlist-empty-state h2 {\n  margin: 0 0 8px;\n  color: var(--wish-text);\n  font-size: 1.35rem;\n}\n\n.wishlist-empty-state p {\n  margin: 0;\n  color: var(--wish-muted);\n}\n\n.wishlist-empty-state .continue-btn {\n  margin-top: 14px;\n}\n\n@media (max-width: 768px) {\n  .wishlist-container {\n    width: 94%;\n    border-radius: 16px;\n    padding: 14px;\n  }\n\n  .wishlist-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 10px;\n  }\n\n  .wishlist-card {\n    padding: 10px;\n    border-radius: 12px;\n  }\n\n  .wishlist-card img {\n    height: 130px;\n  }\n\n  .wishlist-card h3 {\n    font-size: 0.86rem;\n  }\n\n  .wishlist-card p {\n    font-size: 0.85rem;\n  }\n\n  .wishlist-buttons {\n    grid-template-columns: 1fr;\n  }\n\n  .move-btn,\n  .remove-btn {\n    min-height: 34px;\n    font-size: 12px;\n  }\n}\n\n/* Match shared Footer style with homepage */\n.blue-text {\n  color: #3391ff;\n}\n\n.yellow-text {\n  color: #f3bd29;\n}\n\n.footer {\n  --footer-bg: linear-gradient(140deg, #12283f 0%, #173b5d 52%, #1f4f78 100%);\n  --footer-text: #e8f0f8;\n  --footer-muted: #c7d5e3;\n  --footer-border: rgba(255, 255, 255, 0.14);\n  --footer-highlight: #f3bd29;\n  margin: 70px 0 -12px;\n  padding: 40px clamp(18px, 3vw, 42px) 18px;\n  color: var(--footer-text);\n  background: var(--footer-bg);\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  box-shadow: 0 -18px 42px rgba(8, 29, 47, 0.2);\n  box-sizing: border-box;\n  font-family: \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.footer-main {\n  width: min(1240px, 100%);\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: minmax(260px, 1.3fr) minmax(160px, 1fr) minmax(160px, 1fr) minmax(220px, 1.1fr);\n  gap: clamp(18px, 3vw, 36px);\n  align-items: flex-start;\n}\n\n.footer-brand-block {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.footer-brand {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  text-decoration: none;\n}\n\n.footer-brand img {\n  width: 64px;\n  height: 64px;\n  object-fit: contain;\n}\n\n.footer-brand h2 {\n  margin: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: clamp(22px, 2.1vw, 28px);\n  letter-spacing: 0.02em;\n}\n\n.footer-description {\n  margin: 0;\n  max-width: 34ch;\n  color: var(--footer-muted);\n  line-height: 1.65;\n  font-size: 14px;\n}\n\n.footer-contact-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.footer-contact-list a {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  color: var(--footer-text);\n  text-decoration: none;\n  font-size: 14px;\n  width: fit-content;\n}\n\n.footer-contact-list a:hover {\n  color: var(--footer-highlight);\n}\n\n.footer-contact-list a svg {\n  color: var(--footer-highlight);\n  flex-shrink: 0;\n}\n\n.footer-link-group {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.footer-link-group h3,\n.footer-social-block h3 {\n  margin: 0 0 8px;\n  font-size: 18px;\n  color: #ffffff;\n  letter-spacing: 0.01em;\n}\n\n.footer-link-group a {\n  color: var(--footer-muted);\n  text-decoration: none;\n  font-size: 14px;\n  width: fit-content;\n  transition: color 0.2s ease;\n}\n\n.footer-link-group a:hover {\n  color: #ffffff;\n}\n\n.footer-social-block {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.footer-social-block p {\n  margin: 0;\n  color: var(--footer-muted);\n  line-height: 1.6;\n  font-size: 14px;\n}\n\n.footer-social-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(120px, 1fr));\n  gap: 10px;\n}\n\n.footer-social-item {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 42px;\n  border: 1px solid var(--footer-border);\n  border-radius: 999px;\n  color: #ffffff;\n  text-decoration: none;\n  font-size: 13px;\n  font-weight: 600;\n  background: rgba(255, 255, 255, 0.06);\n  transition:\n    transform 0.2s ease,\n    background-color 0.2s ease,\n    border-color 0.2s ease;\n}\n\n.footer-social-item:hover {\n  transform: translateY(-2px);\n  background: rgba(255, 255, 255, 0.14);\n  border-color: rgba(255, 255, 255, 0.26);\n}\n\n.footer-bottom {\n  width: min(1240px, 100%);\n  margin: 28px auto 0;\n  padding-top: 14px;\n  border-top: 1px solid rgba(255, 255, 255, 0.16);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  color: var(--footer-muted);\n  font-size: 13px;\n}\n\n.footer-bottom-links {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.footer-bottom-links a {\n  color: var(--footer-muted);\n  text-decoration: none;\n}\n\n.footer-bottom-links a:hover {\n  color: #ffffff;\n}\n\n@media screen and (max-width: 1080px) {\n  .footer-main {\n    grid-template-columns: repeat(2, minmax(220px, 1fr));\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .footer {\n    margin-top: 48px;\n    padding: 30px 16px 90px;\n  }\n\n  .footer-main {\n    grid-template-columns: 1fr;\n    gap: 24px;\n  }\n\n  .footer-social-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .footer-bottom {\n    flex-direction: column;\n    align-items: flex-start;\n    font-size: 12px;\n  }\n\n  .footer-bottom-links {\n    gap: 12px;\n    flex-wrap: wrap;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
